<template>
  <v-card class="identify-person-dialog">
    <v-card-title class="identify-person-dialog__close pa-0">
      <v-btn
        text
        icon
        plain
        depressed
        class="ma-0"
        @click="close"
      >
        <v-icon
          small
        >
          mdi-close-thick
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text
      class="pa-0 identify-person-dialog__title"
    >
      IDENTIFICAR CLIENTE
    </v-card-text>

    <v-card-text
      class="pa-0 my-3"
    >
      Identifique o cliente para que seja possível vincular a seleção de produtos ao perfil.
    </v-card-text>

    <v-select
      v-model="personType"
      :items="personTypes"
      item-text="title"
      item-value="type"
      placeholder="Selecione o tipo do cliente"
      hide-details
      :menu-props="{ bottom: true, offsetY: true }"
    >
      <template #item="{ item }">
        <v-list-tile-content class="identify-person-dialog__select">
          {{ item.title }}
        </v-list-tile-content>
      </template>
    </v-select>

    <v-text-field
      v-if="notForeigner"
      v-model="personCpf"
      :placeholder="`Digite aqui o ${personType === 'PF' ? 'CPF' : 'CNPJ'} do cliente`"
      hide-details
      :mask="documents[personType].mask"
      color="#140C22"
      class="mt-4"
    >
      <template #label>
        <span class="identify-person-dialog__cpf-label">
          {{ personType === 'PF' ? 'CPF' : 'CNPJ' }}
        </span>
      </template>
    </v-text-field>

    <v-text-field
      v-if="!notForeigner && personType"
      v-model="foreignDocument"
      :placeholder="`Digite o doc. estrangeiro do cliente`"
      hide-details
      color="#140C22"
      class="mt-4"
    >
      <template #label>
        <span class="identify-person-dialog__cpf-label">
          Documento Estrangeiro
        </span>
      </template>
    </v-text-field>

    <v-card-actions
      v-if="personType"
      class="identify-person-dialog__actions pa-0"
    >
      <v-btn
        class="identify-person-dialog__btn"
        medium
        depressed
        dark
        color="#140C22"
        @click="identifyPerson"
      >
        Confirmar
      </v-btn>
      <v-btn
        v-if="personType === 'PF' || personType === 'FOREIGNER'"
        class="identify-person-dialog__btn ma-0 mt-2"
        medium
        depressed
        outline
        color="#140C22"
        @click="goToPersonalize(false)"
      >
        Continuar sem identificar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
  props: {
    goToPersonalize: {
      type: Function,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    personCpf: '',
    foreignDocument: '',
    personType: '',
    personTypes: [
      { title: 'Pessoa Jurídica', type: 'PJ' },
      { title: 'Cliente com CPF', type: 'PF' },
      { title: 'Cliente estrangeiro sem CPF', type: 'FOREIGNER' },
    ],
    documents: {
      PF: { mask: '###.###.###-##' },
      PJ: { mask: '##.###.###/####-##' },
    },
  }),
  computed: {
    notForeigner() {
      return !!this.personType && this.personType !== 'FOREIGNER';
    },
  },
  methods: {
    emitSnackbar(text) {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = text;
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },
    identifyPerson() {
      const document = this.notForeigner ? this.personCpf : this.foreignDocument;

      this.$store.dispatch('setPerson', {
        cpf: document,
        type: this.personType,
      });
      this.$store.dispatch('setPersonAsIdentified', true);

      this.emitSnackbar('Cliente identificado com sucesso');
      this.goToPersonalize();
    },
  },
};
</script>

<style scoped lang="scss">

.identify-person-dialog {
  width: 100%;
  padding: 8px 28px 40px;
  font-family: 'Nunito Sans';
  font-weight: 600;
  font-size: 14px;
  line-height: 102%;
  text-transform: none;
  border-radius: 7px;
  &__title {
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    text-transform: uppercase;
  }
  &__actions {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: stretch;
    height: fit-content;
    max-width: 323px;
    margin: 40px 0 0 !important;
  }
  &__btn {
    height: 38px;
    border-radius: 7.08982px;
    text-transform: none;
    font-weight: 600;
  }
  &__close {
    display: flex;
    justify-content: end;
    transform: translateX(20px);
  }
  &__cpf-label {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.87);
  }
  &__select {
    font: 400 16px/19px 'Roboto';
    color: rgba(0, 0, 0, 0.87);
  }
}

::v-deep .v-select__slot {
  font: 400 16px/19px 'Roboto' !important;
}

::v-deep .v-list__tile {
  border: none;
  padding: 0 16px;
}
</style>
